<template>
	<div class="container-fluid no-padding-sides">
		<div id="home-carousel" class="carousel slide" data-ride="carousel">
		  <!-- Indicators -->
		  <ol class="carousel-indicators">
		  	<li data-target="#home-carousel" :class="{ 'active': slider.active }" v-for="slider in render_sliders" :data-slide-to="$index"></li>
		  </ol>

		  <!-- Wrapper for slides -->
		  <div id="carousel-home" class="carousel-inner" role="listbox">
		  	<a :href="slider.url" class="item" v-for="slider in render_sliders" :class="{ 'active': slider.active }">
		  		<div class="slider-img" :style="`background-image: url(${ getImage(slider) })`"></div>
		  		<!-- <img class="img-responsive" :src="getImage(slider)" alt="slider1"> -->
		      <!-- <div class="carousel-caption-white" v-if="slider.text">
		        <p>{{ slider.text }}</p>
		      </div> -->
		  	</a>
		  </div>

		  <!-- Left and right controls -->
		  <span class="left carousel-control" href="#home-carousel" role="button" data-slide="prev" v-if="render_sliders.length">
		    <img class="img-responsive chevron-left" src="../../images/chevron-left-black.png" alt="">
		    <span class="sr-only"></span>
		  </span>
		  <span class="right carousel-control" href="#home-carousel" role="button" data-slide="next" v-if="render_sliders.length">
		    <img class="img-responsive chevron-right" src="../../images/chevron-right-black.png" alt="">
		    <span class="sr-only"></span>
		  </span>
		</div>
	</div>
</template>

<style scoped>
	
</style>

<script>
import { api_base } from '../../store/api';

export default {
	// ---- VUEX ----

	vuex: {
		getters: {
			sliders: state => state.public_sliders
		}
	},

	// ---- METHODS ----

	methods: {
		getImage(slider) {
			return `${ api_base }/sliders/${ slider.id }`;
		},

		changeLocation(slider) {
			window.location = slider.url;
		}
	},

	// ---- RENDER ----

	computed: {
		render_sliders() {
			if (this.sliders.length) {
				this.sliders[0].active = true;
			}

			return this.sliders;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Carousel.vue?8a76f10e